import { render, staticRenderFns } from "./MatchesTable.vue?vue&type=template&id=56d03b60"
import script from "./MatchesTable.vue?vue&type=script&lang=js"
export * from "./MatchesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports